'use client'
import Image from "next/image";
import Link from "next/link";
import React, { useState } from 'react';

const images = [
    "/project-img/stockprice1.png",
    "/project-img/stockprice2.png",

];



const features = [
    "LSTM Neural Network Architecture",
    "30-day Sequence Learning",
    "Real-time Data from Yahoo Finance",
    "Standard Scaler Preprocessing",
    "RMSE Performance Metrics",
    "80/20 Train-Test Split"
];

const techStack = ["Python", "PyTorch", "Pandas", "NumPy", "scikit-learn", "yfinance", "Matplotlib"];

const modelDetails = [
    "Sequence Length: 30 Days",
    "Hidden Dimension: 32",
    "LSTM Layers: 2",
    "Learning Rate: 0.01",
    "Optimizer: Adam",
    "Loss Function: MSELoss",
    "Epochs: 200"
];

const results = [
    { label: "Training RMSE", value: "~5.49" },
    { label: "Testing RMSE", value: "~10.10" }
];

export function Gallery() {


    return (
        <div className="columns-1 sm:columns-2 md:columns-3 gap-4 space-y-4">
            {images.map((src, index) => (
                <div
                    key={index}
                    className="relative group break-inside-avoid"
                >
                    {/* Glow Effect */}
                    <div className="absolute -inset-1 rounded-3xl blur opacity-20 group-hover:opacity-40 transition duration-500"></div>

                    {/* Image Card */}
                    <div className="relative rounded-2xl overflow-hidden border border-slate-200 bg-white/50">
                        <img
                            src={src}
                            alt={`Gallery ${index}`}
                            className="w-full h-auto rounded-2xl object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}

export default function Page() {

    const [activeTab, setActiveTab] = useState('overview');

    return (
        <main className="py-12 px-6 md:px-12 max-w-7xl mx-auto space-y-10 border-b border-slate-50">
            <div className="pt-2 flex items-center font-bold text-xs gap-1.5 group/btn cursor-pointer">
                <Link href="/" className="flex items-center gap-1.5">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 transform group-hover/btn:translate-x-1 transition" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                    <span className="hover:text-blue-500">Back Page</span>
                </Link>
            </div>

            {/* Hero Section */}
            <section className="space-y-6">
                <div className="space-y-6">
                    <h1 className="text-3xl  font-bold  leading-tight">
                        Stock Price Prediction Model
                    </h1>
                    <p className="text-xl text-slate-600 ">
                        A powerful and efficient Stock Price Prediction Model that forecasts future stock prices using Machine Learning / LSTM techniques.
                    </p>

                    <div className="flex gap-4">
                        <span className="px-4 py-2 rounded-full border border-[var(--accent-cyan)] text-[var(--accent-cyan)] text-sm font-semibold shadow-[0_0_10px_rgba(8,145,178,0.1)]">
                            PyTorch
                        </span>
                        <span className="px-4 py-2 rounded-full border border-[var(--accent-purple)] text-[var(--accent-purple)] text-sm font-semibold shadow-[0_0_10px_rgba(124,58,237,0.1)]">
                            lstm
                        </span>
                       
                    </div>
                </div>
                <div className=" ">
                    <Gallery />
                </div>
            </section>


            <section>
                <section className="py-12">












                    <div className="">
                        {/* Header */}
                        <div className="mb-12">
                            <h1 className="text-4xl font-bold mb-3">Stock Price Prediction with LSTM</h1>
                            <p className="text-gray-600 text-lg">
                                A deep learning-based forecasting system using Long Short-Term Memory networks to predict stock prices from historical data.
                            </p>
                        </div>

                        {/* Stats Cards */}
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <div className="text-2xl font-bold text-gray-900">1,557</div>
                                <div className="text-sm text-gray-600">Training Days</div>
                            </div>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <div className="text-2xl font-bold text-gray-900">80/20</div>
                                <div className="text-sm text-gray-600">Train/Test Split</div>
                            </div>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <div className="text-2xl font-bold text-gray-900">200</div>
                                <div className="text-sm text-gray-600">Training Epochs</div>
                            </div>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <div className="text-2xl font-bold text-gray-900">30</div>
                                <div className="text-sm text-gray-600">Sequence Length</div>
                            </div>
                        </div>

                        {/* Overview Section */}
                        <div className="mb-12">
                            <h2 className="text-2xl font-semibold mb-4">Overview</h2>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                This project implements a stock price prediction model using LSTM (Long Short-Term Memory) networks,
                                specifically designed to capture long-term dependencies in sequential financial data. The model is trained
                                on historical closing prices and uses a 30-day window to predict the next day's price.
                            </p>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {results.map((result, idx) => (
                                    <div key={idx} className="border border-gray-200 rounded-lg p-4">
                                        <div className="text-3xl font-bold text-gray-900 mb-1">{result.value}</div>
                                        <div className="text-gray-600">{result.label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Tech Stack Section */}
                        <div className="mb-12">
                            <h2 className="text-2xl font-semibold mb-4">Tech Stack</h2>
                            <div className="flex flex-wrap gap-2">
                                {techStack.map((tech, idx) => (
                                    <span key={idx} className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm">
                                        {tech}
                                    </span>
                                ))}
                            </div>
                        </div>

                        {/* Model Details Section */}
                        <div className="mb-12">
                            <h2 className="text-2xl font-semibold mb-4">Model Details</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {modelDetails.map((detail, idx) => (
                                    <div key={idx} className="border-b border-gray-100 py-2">
                                        <span className="text-gray-700">{detail}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Features Section */}
                        <div className="mb-12">
                            <h2 className="text-2xl font-semibold mb-4">Features</h2>
                            <ul className="space-y-2">
                                {features.map((feature, idx) => (
                                    <li key={idx} className="flex items-start gap-2">
                                        <span className="text-gray-400">→</span>
                                        <span className="text-gray-700">{feature}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                  
                    </div>
















                </section>
            </section>


        </main >
    );
}
